
<template>
  <section class="h-full w-full flex flex-wrap bg-gray-50 justify-start">

    <!-- Filtros de fecha personalizados -->
    <div class="w-full bg-white p-4 mb-4 shadow-sm border-b">
        <div class="flex flex-wrap gap-4 items-center">
            <!-- Selector de tipo de filtro -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Tipo de filtro:</label>
                <select v-model="tipoFiltroFecha" @change="cambiarTipoFiltro" 
                        class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="mes">Por mes</option>
                    <option value="personalizado">Fechas personalizadas</option>
                </select>
            </div>

            <!-- Filtro por mes -->
            <div v-if="tipoFiltroFecha === 'mes'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Seleccionar mes:</label>
                <input type="month" v-model="mesSeleccionado" @change="aplicarFiltroMes" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <!-- Filtro personalizado -->
            <div v-if="tipoFiltroFecha === 'personalizado'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Fecha inicio:</label>
                <input type="date" v-model="fechaInicioPersonalizada" @change="aplicarFiltroPersonalizado" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <div v-if="tipoFiltroFecha === 'personalizado'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Fecha fin:</label>
                <input type="date" v-model="fechaFinPersonalizada" @change="aplicarFiltroPersonalizado" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <!-- Botones de acciones rápidas -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Acciones rápidas:</label>
                <div class="flex gap-2">
                    <button @click="establecerMesActual" 
                            class="px-3 py-2 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
                        Mes actual
                    </button>
                    <button @click="establecerMesAnterior" 
                            class="px-3 py-2 bg-gray-500 text-white text-xs rounded hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
                        Mes anterior
                    </button>
                    <button @click="establecerUltimos3Meses" 
                            class="px-3 py-2 bg-green-500 text-white text-xs rounded hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500">
                        Últimos 3 meses
                    </button>
                </div>
            </div>

            <!-- Mostrar rango actual -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Rango actual:</label>
                <div class="text-sm text-gray-600 bg-gray-100 px-3 py-2 rounded">
                    <span class="font-medium">{{ formatDateES(fechaRango[0]) }}</span> - 
                    <span class="font-medium">{{ formatDateES(fechaRango[1]) }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Mostrar tabla cuando hay datos -->
    <Tabla
      :idt="'tablll'"
      :key="reftable"
      v-if="data && data.length > 0"
      :add="false"
      :columns="headings"
      :rows="data"
      :filtros="['email', 'phone', 'id']"
      :buscarp="buscar"
      :filtroApi="true"
    />
    
    <!-- Mostrar mensaje cuando no hay datos -->
    <div v-else-if="data && data.length === 0" class="w-full h-full flex items-center justify-center">
        <div class="text-center p-8">
            <p class="text-gray-500 text-lg">No hay datos para mostrar</p>
            <p class="text-gray-400 text-sm mt-2">Intenta ajustar los filtros de búsqueda o el rango de fechas</p>
        </div>
    </div>
    
    <div class="fixed bottom-0 bg-yellow-500 h-12 flex flex-wrap justify-start content-center w-full">
      <p>Total:<span class="font-extrabold">{{formatPrice(getTotal())}}</span></p>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useUserStore } from '@/stores/user';
import Tabla from "@/components/Tabla.vue";
import reportes from "@/Services/reportes";
import productos from "@/Services/productos";
import { emitter } from "@/mitt.js";
import { useMixin } from '@/functions/useMixins';
export default {
  components: {
    Tabla
  },
  setup() {
    const { formatPrice } = useMixin();
    const user = useUserStore();
    const headings = ref([
                  {
                      key: 'id',
                      name: '#',
                      class: 'min-w-[120px]',
                      show: true
                  },
                  {
                      key: 'pedido_id',
                      name: '# pedido',
                      class: 'min-w-[120px]',
                      show: true
                  },
                  {
                      key: 'clientes_cotizaciones',
                      name: 'Cliente',
                      show: true
                  }
                  , {
                      key: 'status_ordenes',
                      class: 'min-w-[200px]',
                      name: 'Estatus Orden',
                      show: true
                  },
                  {
                      key: 'fecha_creacion',
                      name: 'Fecha de creación',
                      class: 'min-w-[160px]',
                      show: true
                  },
                  {
                      key: 'fecha_pedido',
                      name: 'Fecha de pedido',
                      class: 'min-w-[160px]',
                      show: true
                  },
                  {
                      key: 'fecha_llegada',
                      class: 'min-w-[160px]',
                      name: 'Fecha llegada',
                      show: true
                  },
                  {
                      key: 'fecha_pago',
                      name: 'Fecha de pago',
                      class: 'min-w-[160px]',
                      show: true
                  }
                 
                  , {
                      key: 'cotizaciones_id',
                      class: 'min-w-[200px]',
                      name: '# venta',
                      show: true
                  },
  
                  {
                      key: 'numero_factura',
                      name: '# Factura',
                      class: 'min-w-[160px]',
                      show: true
                  },  {
                      key: 'proveedor',
                      name: 'Proveedor',
                      class: 'min-w-[160px]',
                      show: true
                  }, {
                      key: 'total',
                      name: 'Total',
                      show: true
                  },
  
                  {
                      key: 'observaciones',
                      class: 'min-w-[200px]',
                      name: 'Observaciones',
                      show: true
                  },
                  {
                      key: 'usuario',
                      name: 'Empleado',
                      class: 'min-w-[160px]',
                      show: true
                  },
                  
                  {
                      key: 'edit_orden',
                      name: 'Editar',
                      show: true
                  },
                  {
                      key: 'eliminar',
                      name: 'Eliminar',
                      show: true
                  }
              ],);

    const data = ref([]);
    const reftable = ref(0);

    const showM = ref(false);
    const id = ref(0);
    const nombre = ref('');
    const telefono = ref('');
    const correo = ref('');
    const rfc = ref('');
    const buscar = ref('all');
    const pagina = ref(1);
    
    // Nuevas variables para filtros de fecha avanzados
    const fechaRango = ref([getDefaultStartDate(), getDefaultEndDate()]);
    const tipoFiltroFecha = ref('mes'); // 'mes' o 'personalizado'
    const mesSeleccionado = ref(getCurrentYearMonth());
    const fechaInicioPersonalizada = ref(formatDateEN(getDefaultStartDate()));
    const fechaFinPersonalizada = ref(formatDateEN(getDefaultEndDate()));
    
    // Variables originales para compatibilidad
    const fechaInicio = ref(getDefaultStartDate());
    const fechaFin = ref(getDefaultEndDate());
      const applyDateRange = () => {
        getData();
      }
    const getData = async () => {
      let dat = {
        //  page: pagina.value,
          fechaInicio: formatFecha(fechaRango.value[0]), // Usa el rango de fechas nuevo
          fechaFin: formatFecha(fechaRango.value[1]),     // Usa el rango de fechas nuevo
        }
      
      console.log('📊 Cargando reporte de órdenes con filtros:', dat);
      
      emitter.emit("loading", true);
      try {
        const response = await reportes.GET_ORDENES(dat);
        if (response && !response.hasOwnProperty('error')) {
          data.value = response;
          reftable.value = reftable.value + 1;
          console.log('✅ Datos cargados correctamente:', response.length, 'registros');
        }
      } catch (error) {
        console.log('❌ Error al cargar datos:', error);
        // Handle error
      }
      emitter.emit("loading", false);
    };
const getTotal=()=>{
  let tot = 0;

if (data.value && Array.isArray(data.value)) {
  data.value.forEach(element => {
    if (element &&  !isNaN(element.total)) {
      tot += Number(element.total);
    }
  });
}
return (tot).toFixed(2);
 
}
    const getDataProductos = async () => {
      showM.value = false;
      emitter.emit("loading", true);
      try {
        const response = await productos.OPCION(user.value.token);
        if (response) {
          data_productos.value = response;
        }
      } catch (error) {
        // Handle error
      }
      emitter.emit("loading", false);
    };

    const addRow = () => {
      showM.value = !showM.value;
      limpiar();
    };

    const limpiar = () => {
      id.value = 0;
      nombre.value = '';
      telefono.value = '';
      correo.value = '';
      rfc.value = '';
    };
    const formatFecha=(fecha) =>{
        const dateObj = new Date(fecha);
        return dateObj.toISOString();
      const formattedDate = `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`;
      return formattedDate;
    }
      // Función para obtener el primer día del mes actual
      function getDefaultStartDate() {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), 1);
      }
  
      // Función para obtener el último día del mes actual
      function getDefaultEndDate() {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth() + 1, 0);
      }

    // ===== FUNCIONES AUXILIARES PARA FILTROS DE FECHA =====
    function getCurrentYearMonth() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    }

    function formatDateEN(date) {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function formatDateES(date) {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString('es-ES');
    }
    
    // ===== MÉTODOS PARA FILTROS DE FECHA AVANZADOS =====
    const cambiarTipoFiltro = () => {
        console.log('🔄 Cambiando tipo de filtro a:', tipoFiltroFecha.value);
        if (tipoFiltroFecha.value === 'mes') {
            aplicarFiltroMes();
        } else {
            aplicarFiltroPersonalizado();
        }
    };
    
    const aplicarFiltroMes = () => {
        if (!mesSeleccionado.value) return;
        
        const [year, month] = mesSeleccionado.value.split('-');
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);
        
        fechaRango.value = [firstDay, lastDay];
        console.log('📅 Aplicando filtro por mes:', mesSeleccionado.value, 'Rango:', firstDay, 'a', lastDay);
        getData();
    };
    
    const aplicarFiltroPersonalizado = () => {
        if (!fechaInicioPersonalizada.value || !fechaFinPersonalizada.value) return;
        
        const fechaInicio = new Date(fechaInicioPersonalizada.value);
        const fechaFin = new Date(fechaFinPersonalizada.value);
        
        // Validar que la fecha de inicio no sea mayor que la fecha fin
        if (fechaInicio > fechaFin) {
            alert('La fecha de inicio no puede ser mayor que la fecha de fin');
            return;
        }
        
        fechaRango.value = [fechaInicio, fechaFin];
        console.log('📅 Aplicando filtro personalizado:', fechaInicio, 'a', fechaFin);
        getData();
    };
    
    const establecerMesActual = () => {
        tipoFiltroFecha.value = 'mes';
        mesSeleccionado.value = getCurrentYearMonth();
        aplicarFiltroMes();
    };
    
    const establecerMesAnterior = () => {
        const now = new Date();
        const mesAnterior = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const year = mesAnterior.getFullYear();
        const month = String(mesAnterior.getMonth() + 1).padStart(2, '0');
        
        tipoFiltroFecha.value = 'mes';
        mesSeleccionado.value = `${year}-${month}`;
        aplicarFiltroMes();
    };
    
    const establecerUltimos3Meses = () => {
        const now = new Date();
        const hace3Meses = new Date(now.getFullYear(), now.getMonth() - 2, 1);
        const finMesActual = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        
        tipoFiltroFecha.value = 'personalizado';
        fechaInicioPersonalizada.value = formatDateEN(hace3Meses);
        fechaFinPersonalizada.value = formatDateEN(finMesActual);
        aplicarFiltroPersonalizado();
    };
    // ===== FIN MÉTODOS PARA FILTROS DE FECHA =====

    onMounted(async () => {
      // Aplicar filtro de mes actual por defecto
      aplicarFiltroMes();
      getDataProductos();
    });

    return {
      formatPrice,
      getTotal,
      applyDateRange,
      formatFecha,
      formatDateES,
      headings,
      data,
      reftable,
      showM,
      id,
      nombre,
      telefono,
      correo,
      rfc,
      buscar,
      pagina,
      getData,
      getDataProductos,
      addRow,
      limpiar,
      fechaInicio,
      fechaFin,
      // Nuevas variables y métodos para filtros avanzados
      fechaRango,
      tipoFiltroFecha,
      mesSeleccionado,
      fechaInicioPersonalizada,
      fechaFinPersonalizada,
      cambiarTipoFiltro,
      aplicarFiltroMes,
      aplicarFiltroPersonalizado,
      establecerMesActual,
      establecerMesAnterior,
      establecerUltimos3Meses
    };
  },
};
</script>

  